export class GeocodeAddressModel {
  addressCity: string;
  addressLineOne: string;
  addressLineTwo: string;
  addressState: string;
  addressZIP: string;
}
